import { Target, AlertTriangle, Pill } from "lucide-react";

interface ThreeLineSummaryProps {
  core: string;
  redFlag: string;
  treatment: string;
}

export function ThreeLineSummary({ core, redFlag, treatment }: ThreeLineSummaryProps) {
  return (
    <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-muted-foreground uppercase tracking-wider">
        3줄 요약
      </h3>
      <div className="space-y-2.5">
        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-blue/15 text-clinical-blue">
            <Target className="h-3.5 w-3.5" />
          </div>
          <div>
            <span className="text-xs font-semibold text-clinical-blue">핵심</span>
            <p className="text-sm leading-relaxed">{core}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-red/15 text-clinical-red">
            <AlertTriangle className="h-3.5 w-3.5" />
          </div>
          <div>
            <span className="text-xs font-semibold text-clinical-red">Red Flag</span>
            <p className="text-sm leading-relaxed">{redFlag}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-green/15 text-clinical-green">
            <Pill className="h-3.5 w-3.5" />
          </div>
          <div>
            <span className="text-xs font-semibold text-clinical-green">1차 치료</span>
            <p className="text-sm leading-relaxed">{treatment}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
